import { errors } from "@/dictionary";
import { isType } from "@/utils/common.utils";
import { isDevEnv } from "./utils";

/**
 * Analysis the error object and returns the error message or default error message
 * @param {Object} error Error object
 * @returns {String} Error message to be shown to the user
 */
export const errorMessage = (error) => {
  return (error && error?.message) || errors.common.msg;
};

/**
 * Freezes object or arrays and make them immutable
 * @param {Object | Array} object object to be freezed
 */
export const freeze = (object) => {
  const ERROR = "Freeze method accepts object or array as parameter.";

  if (isType(object, "object") || Array.isArray(object)) {
    return Object.freeze(object);
  } else {
    throw new Error(ERROR);
  }
};

/**
 * Print params in console only in dev mode
 * @param {Any} params Any primitive or non primitive value which is to be printed in console
 */
export const debug = (...params) => {
  return isDevEnv() && console.log(`debug :>>`, ...params);
};
